export const getById = (list, selected_id, id_name) => {
    if (list)
        return list.find(item => item[id_name] === selected_id);
    return [];
}

export const listFilter = (list, selected_id, id_name) => {
    if (list) {
        if (selected_id === 'all') {
            return list;
        }
        return list.filter(item => item[id_name] === selected_id);
    }
    return [];
}

export const includeString = (main_string, sub_string) => {
    return main_string && main_string.toLowerCase().includes(sub_string.toLowerCase());
}

export const uniq_by_prop = (prop) => (arr) =>
    Array.from(
        arr.reduce((acc, item) => (
            item && item[prop] && acc.set(item[prop], item), acc
        ), // using map (preserves ordering)
            new Map()
        ).values()
    );